import React from "react";
import {connect} from "react-redux";
import Moment from "moment";

import {FormattedMessage} from "react-intl";
import MaterialsIcons from "../../../Icons/MaterialsIcons";
import {toFixedPrice} from "../../jobEditPopup/jobPricingFunctions";
import {getParsedJobOrder} from "../jobOrderFunctions";
import {downloadFile} from "../../../../utilities/download";


const JobPurchaseOrderInvoiceSuccess = (props) => {

  const {job, purchaseOrderInvoiceFile, purchaseOrderErrorMessage} = props;

  const jobOrder = getParsedJobOrder(job); // jobOrderInterface

  const downloadInvoiceClick = () => {
    downloadFile(jobOrder.invoiceFileUrl, purchaseOrderInvoiceFile.name)
  }

  return (
    <div className={"flex flex--column flex--center relative job-payment__content relative"}>
      <div className="job-payment__status flex flex--center">
        <FormattedMessage id={purchaseOrderErrorMessage
          ? "messageBox.errorTitle"
          : "jobBoard.purchaseOrderPopup.invoiceSuccessLabel"}/>
      </div>
      <div className="job-payment__order-id">
        <span className="pr-15">PO ID: <span className="bold">{jobOrder.orderId}</span></span>
        {purchaseOrderErrorMessage ? null : (
          <span>Invoice ID: <span className="bold">{jobOrder.invoiceId}</span></span>
        )}
      </div>
      {purchaseOrderErrorMessage ? (
        <div className="text-center mb-2">
          <p className="font--16 job-payment__container m-0 color-red">
            {purchaseOrderErrorMessage}
          </p>
        </div>
      ) : (
        <div className="text-center mb-2">
          <p className="font--16 job-payment__container color-charcoal m-0">
            <FormattedMessage id="jobBoard.purchaseOrderPopup.invoiceSuccessText"/>
          </p>
          <p className="font--16 job-payment__container color-charcoal m-0 bold">{jobOrder.parentFabricatorName}</p>
          <div className="flex flex--center color-gray4 font--16 mt-2">
          <span className="pl-15">
            <FormattedMessage
              id="jobBoard.purchaseOrderPopup.orderDate"/>: {(new Moment(jobOrder.orderCreatedAt)).format("MM/DD/YYYY")}
          </span>
            <span className="pl-15">
            <FormattedMessage id="paymentPopup.payment"/>: ${toFixedPrice(jobOrder.referralAmount)}
          </span>
          </div>
          <div className="text-center margin-t24">
            {jobOrder.invoiceFileUrl ? (
              <button className="ui-button5 ui-button5--13 ui-button5--flex ui-button5--flex-icon-left text-uppercase
        ui-button5--flex-icon-left--small ui-button5--gray-border pl-1 pr-1"
                      onClick={downloadInvoiceClick}>
                <span className="ui-button5__material-icon">{MaterialsIcons.DownloadIcon}</span>
                <FormattedMessage id="paymentPopup.invoiceButton"/>
              </button>
            ) : null}
          </div>
        </div>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {job} = store.jobEditPopupState;
  const {
    purchaseOrderInvoiceFile,
    purchaseOrderErrorMessage
  } = store.jobPurchaseOrderPopupState;

  return {
    job,
    purchaseOrderInvoiceFile,
    purchaseOrderErrorMessage,
  };
};

export default (
  connect(mapStateToProps)(JobPurchaseOrderInvoiceSuccess)
)
